(function(){
    angular
        .module('appback')
        .directive('ngValidarhoja', finalizarCont);
        finalizarCont.$inject = ['HojaService','StockService','GenerallabService','$timeout',"$uibModal", 'Upload'];
        function finalizarCont(HojaService,StockService,GenerallabService,$timeout, $uibModal, Upload){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/hojafabricacion/template?name=validarhoja.twig',
		          scope: {
                  hc:'=',
                  categoria:'=',
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
                        scope.unidades_validacion = 0;
                        scope.validado = false;
                        HojaService.getValidacionesHojaFabricacion(scope.hc.idhojafabricacionactiva,scope.categoria.slug,function(dataValidaciones){
                            scope.categoria.validacioneselaborado = dataValidaciones.hojafabricacion.validacioneselaborado;
                            console.log("cat",scope.categoria);
                            console.log('dataValidaciones', dataValidaciones)
                            if(angular.isDefined(dataValidaciones)){
                                scope.dameValidacionesHechas(scope.hc.idhojafabricacionactiva, dataValidaciones.hojafabricacion.categoria.id).then((data)=>{
                                    console.log("validaciones hechas", data);
                                    scope.hojaFabricacion = dataValidaciones.hojafabricacion;
                                    scope.hojaFabricacion.validaciones_hechas = data.validaciones_hechas;
                                    scope.validado = data.validado;
                                    scope.unidades_validacion = data.unidades_validacion;
                                    scope.rol_autorizado = dataValidaciones.hojafabricacion.categoria.roles.includes(dataValidaciones.hojafabricacion.user_role);
                                    console.log("rol_autorizado", scope.rol_autorizado);
                                    console.log("categoria", scope.categoria.slug);
                                    console.log("scope.hc.validacionEstado", scope.hc.validacionesEstado);
                                    scope.hc.validacionesEstado[scope.categoria.slug] = data.validado;
                                    console.log("hojita",scope.hojaFabricacion);
                                });
                            }
                        });

                        scope.init = function(){
                            function loadStock(){
                                StockService.getStockFromHojaId(scope.hc.idhojafabricacionactiva,function(dataStock){
                                    scope.stockInfo = dataStock;
                                    switch (scope.stockInfo.code) {
                                        case -10:
                                            $timeout(loadStock, 5000);
                                            break;
                                        default:
                                            scope.stock = dataStock.stock_de_material;
                                            break;
                                    }
                                });
                            }
                            loadStock();
                        }
                        scope.init();


                        scope.dameValidacionesHechas = function(hoja_id, categoria_id){
                            return HojaService.getValidaciones(hoja_id, categoria_id).then(function(data){
                                return data;
                            })
                        }

                        scope.getIndexValidaciones = function(id_validacionelaborado,_key, categoria) {
                          for (let index = 0; index < scope.hojaFabricacion.validaciones_hechas?.length; index++) {
                              if (scope.hojaFabricacion.validaciones_hechas[index]["id_validacionelaborado"] == id_validacionelaborado){
                                  return index;
                              }
                              
                          }
                          return _key;
                        }
                        scope.okForm = function(){
                            console.log("okForm", scope);
                            if(!angular.isDefined(scope.unidades_validacion) || scope.unidades_validacion == "null" || scope.unidades_validacion == null){
                                scope.unidades_validacion = 0;
                            }
                            HojaService.setValidaciones(scope,function(){})
                        }

                        scope.finalizarValidacion = function(){
                            if(!angular.isDefined(scope.unidades_validacion) || scope.unidades_validacion == "null" || scope.unidades_validacion == null){
                                scope.unidades_validacion = 0;
                            }
                            HojaService.setValidaciones(scope,function(){
                                HojaService.finalizarValidacion(scope, function(data){
                                    console.log("finalizarValidacion", data);
                                    if(data.code>0){
                                        if(data.validacion.validado){
                                            scope.validado = true;
                                            scope.categoria.validada = true;
                                            scope.hc.validacionesEstado[scope.categoria.slug] = true;
                                        }
                                        if(data.acciones){
                                            scope.hc.hojafabricacionactiva.acciones = data.acciones;
                                        }
                                    }
                                })
                            });
                        }

                        scope.confirmarFinalizarValidacion = function() {
                            $('#confirmFinalizarValidacionModal').modal('hide');
                            scope.finalizarValidacion();
                        };

                        scope.popupDesvalidar = "";
                        scope.btnDesvalidar = function(){
                          console.log("btndesvalidar");
                           scope.popupDesvalidar = $uibModal.open({
                              animation: true,
                              ariaLabelledBy: 'modal-title-top',
                              ariaDescribedBy: 'modal-body-top',
                              templateUrl: '/backend/hojafabricacion/template?name=desvalidar.twig',
                              size: 'lg',
                              controller: function($scope) {
                                $scope.comentario = "";
                                $scope.okForm = function(){
                                    console.log("desvalidando la validacion", scope);
                                    HojaService.desvalidarValidacion(scope, $scope.comentario, function(data){
                                        console.log("desvalidarValidacion", data);
                                        if(!data.validacion.validado){
                                            scope.validado = false;
                                            scope.categoria.validada = false;
                                            scope.hc.validacionesEstado[scope.categoria.slug] = false;
                                        }
                                        if(data.acciones){
                                            scope.hc.hojafabricacionactiva.acciones = data.acciones;
                                        }
                                    })
                                   scope.popupDesvalidar.close();
                                }
                                $scope.koForm = function(){
                                    scope.popupDesvalidar.close();
                                }
                              }
                            });
                        }
      

                        scope.camaraEstado = {};
                        
                        scope.abrirCamara = function(tipo, index) {
                            if (scope.camaraEstado[index]) {
                                console.log("La cámara ya está abierta");
                                return;
                            }

                            scope.camaraEstado[index] = true;
                            var video = document.getElementById('video-' + index + '_' + scope.categoria.slug);

                            // Intentar abrir la cámara trasera primero
                            var constraints = {
                                video: { facingMode: { exact: "environment" } },
                                audio: tipo === 'Video'
                            };

                            navigator.mediaDevices.getUserMedia(constraints)
                                .then(function(stream) {
                                    scope.streamActual = stream;
                                    video.srcObject = stream;
                                    video.style.display = 'block';
                                    video.play();
                                })
                                .catch(function(err) {
                                    console.warn("No se pudo abrir la cámara trasera, intentando la frontal...", err);

                                    // Fallback: abrir cámara frontal si la trasera no está disponible
                                    var fallbackConstraints = {
                                        video: { facingMode: "user" },
                                        audio: tipo === 'Video'
                                    };

                                    navigator.mediaDevices.getUserMedia(fallbackConstraints)
                                        .then(function(stream) {
                                            scope.streamActual = stream;
                                            video.srcObject = stream;
                                            video.style.display = 'block';
                                            video.play();
                                        })
                                        .catch(function(err2) {
                                            scope.camaraEstado[index] = false;
                                            scope.cerrarCamara(index);
                                            console.error("No se pudo acceder a ninguna cámara:", err2);
                                        });
                                });
                        };
  
                      scope.cerrarCamara = function(index) {
                          if(scope.streamActual) {
                              var video = document.getElementById('video-' + index + '_' + scope.categoria.slug);
                              scope.streamActual.getTracks().forEach(track => track.stop());
                              video.srcObject = null;
                              video.style.display = 'none';
                              scope.camaraEstado[index] = false;
                              scope.grabando = false;
                          }
                      };
  
                      scope.capturarImagen = function(index) {
                          var video = document.getElementById('video-' + index + '_' + scope.categoria.slug);
                          var canvas = document.getElementById('canvas-' + index + '_' + scope.categoria.slug);
                          canvas.width = video.videoWidth;
                          canvas.height = video.videoHeight;
                          canvas.getContext('2d').drawImage(video, 0, 0);
                          var imageData = canvas.toDataURL('image/png');
                          scope.subirArchivo(dataURItoBlob(imageData), 'imagen.png', index);
                          scope.cerrarCamara(index);
                      };
  
                      scope.grabando = false;
                      scope.mediaRecorder = null;
  
                      scope.iniciarGrabacion = function(index) {
                          if (scope.streamActual) {
                              scope.grabando = true;
                              var chunks = [];
                              scope.mediaRecorder = new MediaRecorder(scope.streamActual);
                              scope.mediaRecorder.ondataavailable = function(e) {
                                  chunks.push(e.data);
                              };
                              scope.mediaRecorder.onstop = function() {
                                  var blob = new Blob(chunks, { type: 'video/mp4' });
                                  scope.subirArchivo(blob, 'video.mp4', index);
                              };
                              scope.mediaRecorder.start();
                          }
                      };
  
                      scope.detenerGrabacion = function(index) {
                          if (scope.mediaRecorder && scope.grabando) {
                              scope.mediaRecorder.stop();
                              scope.grabando = false;
                              scope.cerrarCamara(index);
                          }
                      };
                      
                      scope.audioRecording = false;
                      scope.grabarAudio = function(index) {
                          console.log("navigator", navigator.mediaDevices);
                          scope.audioRecording = true;
                          navigator.mediaDevices.getUserMedia({ audio: true })
                          .then(function(stream) {
                              scope.mediaRecorder = new MediaRecorder(stream);
                              var chunks = [];
                      
                              scope.mediaRecorder.start();
                              console.log("Grabación de audio iniciada");
                      
                              scope.mediaRecorder.ondataavailable = function(e) {
                                  chunks.push(e.data);
                              };
                      
                              scope.mediaRecorder.onstop = function(e) {
                                  console.log("Grabación de audio detenida");
                                  var blob = new Blob(chunks, { 'type' : 'audio/mp3' });
                                  chunks = [];
                                  var audioURL = URL.createObjectURL(blob);
                                  scope.subirArchivo(audioURL, 'audio.mp3', index);
                                  stream.getTracks().forEach(track => track.stop());
                              };
                      
                              /*$timeout(function() {
                                  mediaRecorder.stop();
                              }, 5000);*/
                          })
                          .catch(function(err) {
                              console.log("An error occurred while recording audio: " + err);
                          });
                      };

                      scope.detenerAudio = function(index) {
                        if(scope.audioRecording && scope.mediaRecorder){
                            scope.mediaRecorder.stop();
                            scope.audioRecording = false;  
                        }
                      }
  
                      scope.subirArchivo = function(fileDataBlob, fileName, index) {
                          var file = new File([fileDataBlob], fileName);
                          scope.uploadFiles([file], index);
                      };
  
                      function dataURItoBlob(dataURI) {
                          var byteString = atob(dataURI.split(',')[1]);
                          var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
                          var ab = new ArrayBuffer(byteString.length);
                          var ia = new Uint8Array(ab);
                          for (var i = 0; i < byteString.length; i++) {
                              ia[i] = byteString.charCodeAt(i);
                          }
                          return new Blob([ab], {type: mimeString});
                        }
  
                        scope.uploadFiles = function (files, index_validacion) {
                          if (files && files.length) {
                            for (var i = 0; i < files.length; i++) {
                              console.log("Fichero a subir", files[i]);
                              Upload.upload({
                                    url: '/backend/hojafabricacion/subirvalidacion',
                                    data: { file: files[i] }
                                }).then(function (resp) {
                                  console.log(scope.hojaFabricacion[index_validacion])
                                    if (resp.data.code > 0) {
                                      if (!angular.isDefined(scope.hojaFabricacion.validaciones_hechas[index_validacion]?.files)) {
                                          scope.hojaFabricacion.validaciones_hechas[index_validacion].files = [];
                                      }
                                      scope.hojaFabricacion.validaciones_hechas[index_validacion].files.push(resp.data);
                                        
                                    }
                                    
                                }, function (resp) {
                                    //console.log('Error status: ' + resp.status);
                                }, function (evt) {
                                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                                    //console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                                });
                            }
                            
                          }
                        }
                        scope.borrarFichero = function(index,index_validacion){
                          scope.hojaFabricacion.validaciones_hechas[index_validacion].files.splice(index,1)

                        }
			        });
		        }
          }
      }
})();